import axios from "../axios";

class OpenDayService {
    getOpenDayById(id) {
        const url = `open-days/${id}`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getOpenDaysByGroupId(id) {
        const url = `open-days/group/${id}`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

export default new OpenDayService();
